import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

/** How long the non-blocking game alert stays visible after a game opens */
const DISPLAY_MS = 10_000

const ALERT_Z = 100_000

export type GameAlertBannerProps = {
  /** When this becomes truthy (game launching), the alert shows for {@link DISPLAY_MS} then hides. */
  gamePlay: unknown
}

/**
 * Game Alert — 1 Point = 100 Rs in Casino Games.
 * Portal above the casino iframe; pointer-events: none so it does not block play or EXIT.
 */
const GameAlertBanner: React.FC<GameAlertBannerProps> = ({ gamePlay }) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!gamePlay) {
      setVisible(false)
      return
    }
    setVisible(true)
    const t = window.setTimeout(() => setVisible(false), DISPLAY_MS)
    return () => window.clearTimeout(t)
  }, [gamePlay])

  if (!visible) return null

  return createPortal(
    <div className='game-alert-banner__wrap' aria-live='polite'>
      <div className='game-alert-banner' role='status'>
        <div className='game-alert-banner__label'>Game Alert</div>
        <div className='game-alert-banner__message'>1 Point = 100 Rs in Casino Games</div>
      </div>
    </div>,
    document.body,
  )
}

export default GameAlertBanner
